import { useDispatch } from 'react-redux';
import { useKeycloak } from '@react-keycloak/web';
import { addFavorite, removeFavorite } from '../../store/reducers/favorites.reducer';
import { useFavoriteIds } from './useFavoriteIds';

export const useToggleFavorite = () => {
    const dispatch = useDispatch();
    const { keycloak } = useKeycloak();
    const favoriteIds = useFavoriteIds();

    const toggleFavorite = (mediaPoint) => {
        if (!keycloak.token) return;

        const isCurrentlyFavorite = favoriteIds.has(mediaPoint.id);
        if (isCurrentlyFavorite) {
            dispatch(removeFavorite({ mediaId: mediaPoint.id, token: keycloak.token }));
        } else {
            dispatch(addFavorite({ mediaPoint, token: keycloak.token }));
        }
    };

    return { toggleFavorite };
}